import { getSize, stepTokenUpOrDown } from "@tamagui/get-size";
const getButtonSized = (val, { tokens }) => {
  if (typeof val === "number") {
    return {
      paddingHorizontal: val * 0.25,
      height: val,
      borderRadius: val * 0.2
    };
  }
  const ySize = getSize(val, 0);
  const xSize = stepTokenUpOrDown("space", val);
  const radiusToken = tokens.radius[val] ?? tokens.radius["$true"];
  return {
    paddingHorizontal: xSize,
    height: ySize,
    borderRadius: radiusToken
  };
};
export {
  getButtonSized
};
//# sourceMappingURL=index.js.map
